import React from "react"
import { CardType } from "../../../../lib/utils"
import InvestorPaymentCard from "./Card"
import ManageInvestorPayment from "./ManageItem"

export default function InvestorPaymentDetails({ params }) {

  return <ManageInvestorPayment
    params={ params }
    callback={ (data, setInvestorPayment, removeInvestorPayment) =>
      <InvestorPaymentCard
        investorPayment={ data }
        setInvestorPayment={ setInvestorPayment }
        removeInvestorPayment={ removeInvestorPayment }
        cardType={ CardType.LARGE }
      />
    }
  />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Payments/Details.js